import { FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import StatusAlertPopup from '../../../../components/moduleCommonFormik/StatusAlertPopup';
import GenericActionTable from '../../../../components/moduleCommonFormik/GenericActionTable';
import GenericButtons from '../../../../components/UI components/Buttons/GenericButtons';
import GenericFormCard from '../../../../components/moduleCommonFormik/GenericFormCard.component';
import GenericHeader from '../../../../components/moduleCommonFormik/GenericHeader';
import Loading from '../../../../components/portalComponents/Loading.component';
import HeaderComponent from '../../../../components/header/Header.component';
import { EMPLOYEE_AUTHORIZED } from '../../../../utils/constants';
import { cross } from '../../../../utils/Logo';
import { endpoints, POST, requestInfo } from '../../../../services/modulesServices/userManagement.api';
import { useTranslation } from 'react-i18next';
import { DESK_PENDENCY_SEARCH, DESK_PENDENCY_SEARCH_TABLE } from './EngineeringSearchApplication.const';
import { ESTATEWISE_SEARCH_VALIDATION } from '../../../../utils/formikValidation/FormikValidation';
import { getFirstErrorKey, getNavigateTo } from '../../../../utils/utils';

export function EngineeringSearchApplicationPage() {
    const [isLoading, setIsLoading] = useState<any>(false);
    const [modalDetails, setModalDetails] = useState<any>({});
    const [tableData, setTableData] = useState<any>([]);
    const { t } = useTranslation();
    const [dropdownData, setDropdownData] = useState<any>(null);
    const [estateData, setEstateData] = useState<any>([]);

    const navigate = useNavigate();
    let userObject = JSON.parse(localStorage.getItem('user') || '{}');
    let userType = userObject?.type;
    const getUserDetails = JSON.parse(localStorage.getItem('user') || '{}');
    const userUuid = getUserDetails?.uuid;
    const formik = useFormik<any>({
        initialValues: {
            isUpdatable: true
        },
        onSubmit: () => {},
        validationSchema: ESTATEWISE_SEARCH_VALIDATION
    });

    const { values, setValues, errors, setFieldTouched } = formik;
    const toGetDropdown = async () => {
        let estateDropdown;
        let dropdowDataCheck;
        try {
            const { data } = await POST(endpoints.estateDropDown + `?userUuids=${userUuid}&isEstateDetailsRequired=true`, { RequestInfo: requestInfo() });
            const estateValues = data?.estateManagers?.map((val: any) => {
                return { estateName: val?.estateDetails?.estateName, estateId: val?.estateDetails?.uuid };
            });
            const typeDropdown = [
                { name: 'Inspection Report', code: 'INSPECTION_REPORT' },
                { name: 'Water Connection Billing', code: 'WATER_CONNECTION_BILLING' }
            ];
            setEstateData(estateValues);
            estateDropdown = estateValues.map((value: any) => {
                return { name: value?.estateName, code: value?.estateName };
            });
            dropdowDataCheck = { industrialEstate: estateDropdown, type: typeDropdown };
            setDropdownData(dropdowDataCheck);
        } catch (e: any) {
            let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
            setModalDetails({ show: true, title: 'Action Unsuccessful', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
        }
    };

    useEffect(() => {
        if (userType !== 'EMPLOYEE') {
            setModalDetails({
                show: true,
                title: t('ERROR', 'Error!'),
                para: t('UNAUTHORIZED_ACCESS', EMPLOYEE_AUTHORIZED),
                img: cross,
                type: 'error',
                reUpload: 'OK',
                isUnauthorized: true
            });
        }
        toGetDropdown();
    }, []);
    const onReset = () => {
        setTableData([]);
        setValues((prev: any) => ({ ...prev, industrialEstate: '', type: '' }));
    };

    const onSearch = async () => {
        try {
            await ESTATEWISE_SEARCH_VALIDATION.validate(values, { abortEarly: false });
            const getEstateId = estateData?.find((val: any) => val?.estateName === values?.industrialEstate?.name);
            try {
                setIsLoading(true);
                const payload = {
                    RequestInfo: requestInfo(),
                    applicationModule: 'Engineering',
                    applicationType: values?.type?.code,
                    currentAssigneeUuid: userUuid || '',
                    estateIds: getEstateId?.estateId ? [getEstateId.estateId] : []
                };
                const { data } = await POST(endpoints.applicationSearch, payload);
                if (data?.inboxs?.length > 0) {
                    const tablerowData =
                        data?.inboxs?.length &&
                        data?.inboxs?.map((val: any, index: number) => {
                            return {
                                applicationType: val?.applicationType,
                                entityName: val?.entityName,
                                estateName: val?.estateName,
                                plotNumber: val?.plotNo,
                                applicationNo: val?.applicationNo,
                                assignedDapplicationSubmissionDateate: val?.applicationSubmissionDate,
                                status: val?.status,
                                deskPendencyDays: val?.deskPendencyDays,
                                navUrl: val?.navUrl
                            };
                        });
                    setTableData(tablerowData);
                    setIsLoading(false);
                } else {
                    setTableData([]);
                    setModalDetails({ show: true, title: 'Error!', para: 'No Data Found', img: cross, type: 'error', reUpload: 'OK' });
                    setIsLoading(false);
                    return;
                }
            } catch (e: any) {
                setIsLoading(false);
                let errMsg = e.response?.data?.errorMessage || e.response?.data?.Errors?.[0]?.message || t('SOMETHING_WENT_WRONG', 'Something went wrong!');
                setModalDetails({ show: true, title: 'Error!', para: errMsg, img: cross, type: 'error', reUpload: 'OK' });
            }
        } catch (e: any) {
            setIsLoading(false);
            setTableData([]);
            let errorField = getFirstErrorKey(errors);
            if (errorField) {
                const escapedErrorField = errorField?.replace(/([[\].])/g, '\\$1');
                await setFieldTouched(errorField, true, true);
                let getErrorField: any = document.querySelector(`[name=${escapedErrorField}]`);
                getErrorField && getErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    };

    const handleModalClose = (type: string) => {
        setModalDetails({});
        onReset();
    };
    const handleRowClick = (rowData: any) => {
        const url = rowData.navUrl;
        if (url) {
            navigate(url);
        }
    };

    return (
        <>
            <HeaderComponent />
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    <div className='employee-creation-container bg-light m-auto px-5 py-4 row'>
                        <GenericHeader text={t('ESTATEWISE_SEARCH_APPLICATION', 'Estate Wise Application Search')} />
                        <div className='col-13 form-section' style={{ marginTop: '-22px' }}>
                            <FormikProvider value={formik}>
                                <div>
                                    <Card className='card_border my-4 pb-4 pe-4'>
                                        <Card.Body>
                                            {DESK_PENDENCY_SEARCH?.map((val: any) => {
                                                return (
                                                    <>
                                                        <GenericFormCard {...val} dropdownOptions={dropdownData} />
                                                    </>
                                                );
                                            })}
                                        </Card.Body>
                                        <div className='d-flex justify-content-end pe-2 pb-1'>
                                            <GenericButtons text={t('RESET', 'Reset')} handleClick={onReset} />
                                            <GenericButtons text={t('SEARCH', 'Search')} disabled={!values?.type?.code} handleClick={onSearch} variant='primary' />
                                        </div>
                                    </Card>
                                    {tableData?.length ? (
                                        <>
                                            <Card className='card_border row mx-1 p-4 pb-0'>
                                                <div className='font-20 project-primary-color lh-base mb-3'>Search Results</div>
                                                <GenericActionTable
                                                    columns={DESK_PENDENCY_SEARCH_TABLE}
                                                    rowData={tableData}
                                                    searchBarPlaceholder={t('SEARCH_ESTATE_FILTER', 'Search by Application No, Estate, Phase or Plot No')}
                                                    hideExportBtn={true}
                                                    additionalMethod={handleRowClick}
                                                />
                                            </Card>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                            </FormikProvider>
                        </div>
                    </div>
                </>
            )}
            <StatusAlertPopup
                title={modalDetails.title}
                para={modalDetails.para}
                img={modalDetails.img}
                show={modalDetails.show}
                handleClose={() => handleModalClose(modalDetails.type)}
                type={modalDetails.type}
                reUpload={modalDetails.reUpload}
                handleSubmit={() => handleModalClose(modalDetails.type)}
            />
        </>
    );
}
